import { OnboardingGeneratingScreen } from "@/components/screens/onboarding/GeneratingScreen"
import { useNavigate } from "@/router"
import { currentAuthAtom } from "@/state/auth"
import { useAtomValue } from "jotai"
import React, { useEffect, useState } from "react"
import { useGetReport, useUpdateAndRegenerateReport } from "@/queries/useReport"
import { reportFormDraftAtom } from "@/state/report"

export default function GeneratingPage() {
	const navigate = useNavigate()
	const auth = useAtomValue(currentAuthAtom)
	const [loaderFinished, setLoaderFinished] = useState(false)
	const report = useGetReport(false)
	const form = useAtomValue(reportFormDraftAtom)
	const { tripsReady, run } = useUpdateAndRegenerateReport()
	const [state, setState] = useState<
		"initial" | "generating" | "error" | "success" | "working"
	>("initial")

	useEffect(() => {
		const generate = async () => {
			switch (state) {
				case "initial": {
					setState("generating")
					break
				}
				case "generating": {
					setState("working")
					try {
						await report.refetch()
						await run(form, true)
						return setState("success")
					} catch (e) {
						console.error("Error generating trips", e)
						return setState("error")
					}
				}
				case "success":
					if (loaderFinished) {
						navigate("/report/:id", {
							params: {
								id: auth.reportId,
							},
						})
					}
					break
				case "error":
				case "working":
					break
			}
		}
		generate()
	}, [state, report.data, tripsReady, loaderFinished])

	return (
		<OnboardingGeneratingScreen
			onNext={() => {
				setLoaderFinished(true)
			}}
		/>
	)
}
